import { useQuery } from '@tanstack/react-query';
import { UserRole } from '../../../types/UserRole';
import CustomAxios from '../../../utility/customAxios';
import { queryKeys } from '../queryKeys';

export const fetchUserRole = async (uuid: string) => {
  const response = await CustomAxios.get<UserRole>(`user_roles/${uuid}`);
  const { data } = response;
  return data;
};

interface UseGetUserRoleByIdProps {
  enabled?: boolean;
  uuid: string;
}
export function useGetUserRoleById({ enabled = true, uuid }: UseGetUserRoleByIdProps) {
  const query = useQuery({
    enabled,
    queryKey: [queryKeys.allUserRoles, uuid],
    queryFn: () => fetchUserRole(uuid),
  });

  return query;
}
